module.exports = __webpack_public_path__ + "img/lun2.3d65828b.png";